var exports = {
  "container": "x31de4314--e2d190--container",
  "has-features": "x31de4314--e2d190--has-features",
  "label": "x31de4314--e2d190--label",
  "lightgrey-label": "x31de4314--e2d190--lightgrey-label",
  "black-label": "x31de4314--e2d190--black-label",
};

module.exports = exports;
